import Swiper from 'swiper';
import { Autoplay, A11y, Pagination } from 'swiper/modules';

export class SpeakerSeminarTeaserSlider {
    constructor() {
        this.speakerSeminarSlider = document.querySelectorAll('.swiper-speaker-seminar-teaser')
        this.baseSwiperOptions = {
            modules: [Autoplay, A11y, Pagination],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            centerInsufficientSlides: false,
            a11y: {
                scrollOnFocus: false
            },
            autoplay: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            },
        };

        this.initSlider()
    }

    initSlider() {
        this.speakerSeminarSlider.forEach((slider) => {
            this.swiper = new Swiper(slider, this.baseSwiperOptions);
        })
    }
}